const config = require('../../../../../config/locales_json/packs/private/admin/users.json');
const language = $('body').data("language");

/*************
* Selección Multiples usuarios
*
*/
jQuery(function() { 

  /****************
  * si la variable de los postulantes tiene valores, se seleccionan los checkbox correspondientes
  */

  if (localStorage.getItem("userIds") !== null) {
    var selectedOnReloadPostulants = localStorage.getItem("userIds").split(',')
    $.each(selectedOnReloadPostulants, function(index, value) {
      $('#check_for_user_'+value).prop("checked", true);
    });
  }
  
  if (localStorage.getItem("userAdminIds") !== null) {
    var selectedOnReloadPostulants = localStorage.getItem("userAdminIds").split(',')
    $.each(selectedOnReloadPostulants, function(index, value) {
      $('#check_for_user_admin_'+value).prop("checked", true);
    });
  }

  /****************
  * si la variable de seleccion de todos los postulantes es true, se selecciona el checkbox
  */

  if (localStorage.getItem("userIdsSelectAll") === "true") {
		$('input#check_for_select_all').prop("checked", true);
  }
  
  if (localStorage.getItem("userAdminIdsSelectAll") === "true") {
		$('input#check_for_select_all_admin').prop("checked", true);
    $('.check_user_admin').prop("checked", true);
	}
  /****************
  * Evento que permite guardar y seleccionar todos los ids de los postulantes
  */
  $('input#check_for_select_all').on('change', function(e){
    // alert($("input[name='check_for_user']:checked").length);
    if ($(this).is(':checked')) {
      if ($("input[name='check_for_user']:checked").length > 0){
        localStorage.setItem("userIdsSelectAll", false);
        localStorage.setItem("userIds", null);
        $('input.check_user').prop("checked", false);
        $('button#menu_bulk_action').prop('disabled', true);
        //$('a#link_download_selected').css('display','none');
        $('a#link_download_selected_mail').css('display','none');
        $('button#menu_bulk_action').addClass('disabled');
        $(this).prop("checked", false);
      }else{
        var all_id_array= $('input#all_ids').val();
        localStorage.setItem("userIdsSelectAll", true);
        localStorage.setItem("userIds", all_id_array);
        $('input.check_user').prop("checked", true);
        $('button#menu_bulk_action').prop('disabled', false);
        //$('a#link_download_selected').css('display','block');
        $('a#link_download_selected_mail').css('display','inline-flex');
        $('button#menu_bulk_action').removeClass('disabled');
      }
		}else{
			localStorage.setItem("userIdsSelectAll", false);
			localStorage.setItem("userIds", null);
      $('input.check_user').prop("checked", false);
      $('button#menu_bulk_action').prop('disabled', true);
      //$('a#link_download_selected').css('display','none');
      $('a#link_download_selected_mail').css('display','none');
			$('button#menu_bulk_action').addClass('disabled');
		}

  });
  
  /****************
  * Evento que permite guardar y seleccionar todos los ids de los postulantes
  */

  $('input#check_for_select_all_admin').on('change', function(e){
    // alert('hola');
    if ($(this).is(':checked')) {
      if ($("input[name='check_for_user']:checked").length > 0){
        localStorage.setItem("userAdminIdsSelectAll", false);
        localStorage.setItem("userAdminIds", null);
        $('input.check_user_admin').prop("checked", false);
        $('button#menu_bulk_action').prop('disabled', true);
        $('a#link_download_selected_user').css('display','none');
        $('button#menu_bulk_action').addClass('disabled');
        $(this).prop("checked", false);
      }else{
        var all_id_array= $('input#all_ids').val();
        localStorage.setItem("userAdminIdsSelectAll", true);
        localStorage.setItem("userAdminIds", all_id_array);
        $('input.check_user_admin').prop("checked", true);
        $('button#menu_bulk_action').prop('disabled', false);
        $('a#link_download_selected_user').css('display','block');
        $('button#menu_bulk_action').removeClass('disabled');
      }
		}else{
			localStorage.setItem("userAdminIdsSelectAll", false);
			localStorage.setItem("userAdminIds", null);
      $('input.check_user_admin').prop("checked", false);
      $('button#menu_bulk_action').prop('disabled', true);
      $('a#link_download_selected_user').css('display','none');
			$('button#menu_bulk_action').addClass('disabled');
		}

	});

  /****************
  * Evento que permite ir guardando y checkeando postulantes individuales
  */
  $("div#user-list").on("click", "input.check_user", function() {
		getPostulantsIds($(this).val())
		userIds = localStorage.getItem('userIds');
		if (localStorage.getItem("userIds") == null || localStorage.getItem("userIds") === ''){
      $('button#menu_bulk_action').prop('disabled', true)
      //$('a#link_download_selected').css('display','none');
      $('a#link_download_selected_mail').css('display','none');
			$('button#menu_bulk_action').addClass('disabled')
		}else{
      $('button#menu_bulk_action').prop('disabled', false);
      //$('a#link_download_selected').css('display','block');
      $('a#link_download_selected_mail').css('display','inline-flex');
			$('button#menu_bulk_action').removeClass('disabled');
		}
  });
  
  /****************
  * Evento que permite ir guardando y checkeando postulantes individuales
  */
  $("div#user-list").on("click", "input.check_user_admin", function() {
		getAdminUsersIds($(this).val())
		userIds = localStorage.getItem('userAdminIds');
		if (localStorage.getItem("userAdminIds") == null || localStorage.getItem("userAdminIds") === ''){
      $('button#menu_bulk_action').prop('disabled', true)
      $('a#link_download_selected_user').css('display','none');
			$('button#menu_bulk_action').addClass('disabled')
		}else{
      $('button#menu_bulk_action').prop('disabled', false);
      $('a#link_download_selected_user').css('display','block');
			$('button#menu_bulk_action').removeClass('disabled');
		}
  });


  // Funcion para Enviar al email los seleccionados
  $("div#list_users").on("click", "a#link_download_selected_user", function(e) {
    e.preventDefault();
    var link_selected= $(this);
    userIds = localStorage.getItem('userAdminIds');
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    if (userIds===null || userIds === "" || userIds === undefined){

    }else{
      $.ajax({
        type: "GET",
        url: '/admin/usuarios/download_all_user',
        dataType: 'script',
        data: {
          ids: userIds,
          authenticity_token: AUTH_TOKEN
        }
      });
    }
  });

  // Evento para limpiar los usuarios seleccionados cuando se realiza un filtros
  $('form#form-postulant-filter').on('submit', function() {
    // Resetear los valores en localStorage
    localStorage.setItem("userAdminIds", null);
    localStorage.setItem("userAdminIdsSelectAll", false);
    
    // Desmarcar todos los checkboxes
    $('input#check_for_select_all_admin').prop("checked", false);
    $('.check_user_admin').prop("checked", false);
  });
  
  // Evento para limpiar los usuarios seleccionados cuando se borran los filtros
  $('#clean-filter-btn').on('click', function(e) {    
    // Resetear los valores en localStorage
    localStorage.setItem("userAdminIds", null);
    localStorage.setItem("userAdminIdsSelectAll", false);
    
    // Desmarcar todos los checkboxes
    $('input#check_for_select_all_admin').prop("checked", false);
    $('.check_user_admin').prop("checked", false);
  });
});

/*************************
* 
* VALIDACION DE CONTRASEÑA
*/
jQuery(function(){
  $("#profileModal").on("click", "#admin-update-user-password", function(e){
    e.preventDefault()

    var password = $("#user-password-form #user_password")
    var passwordConfirmation = $("#user-password-form #user_password_confirmation")
    var error = checkPasswordValidation(password, passwordConfirmation)
    
    if(!error){
      const errorText = getTranslationValue(config, [language, "on_click_admin_update_user_password", "not_error"], 'Actualizando...');
      $(this).text(errorText).addClass("disabled")
      $("#user-password-form").addClass("disabled");
      $("#user-password-form").submit(); 
    } else {
      const text = getTranslationValue(config, [language, "on_click_admin_update_user_password", "else_Swalfire_text"], 'Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.');
      const confirmButtonText = getTranslationValue(config, [language, "on_click_admin_update_user_password", "else_Swalfire_confirmButtonText"], 'Aceptar');

      Swal.fire({
        text: text,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: "btn btn-fj-purple"
        }
      }).then(function () {
        KTUtil.scrollTop();
      });
    }	
  });

  // Evento modal de improtación de usuarios
  $("#list_users").on("click", "#user-import-action", function(e){
    $("#importModal").modal('toggle');
  });

  $("#importModal").on("click", "#send_import", function(e){
    e.preventDefault();
    var userImportInput = $("#importModal #user-import-file").val();

    if (userImportInput.length === 0) {
      Swal.fire({
        text: getTranslationValue(config, [language, "on_click_send_import", "error_swalfire_text"], "Debes subir el archivo antes de realizar la importación"),
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: getTranslationValue(config, [language, "on_click_send_import", "error_swalfire_confirmButtonText"], "Aceptar"),
        customClass: {
            confirmButton: "btn btn-fj-purple"
        }
      });
    } else {
      Swal.fire({
        icon: "info",
        text: getTranslationValue(config, [language, "on_click_send_import", "swalfire_text"],"Subiendo Archivo..."),
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          confirmButton: "action-popup"
        }
      });
      
      $("#importModal #form-modal-user-import").submit();
    }

  });

})

// Metodo para validar la contraseña
function checkPasswordValidation(password, passwordConfirmation) {
  var password = $(password)
  var passwordConfirmation = $(passwordConfirmation)
  var error = 0
  var contPasswordInput = password.parent();
  var contPasswordConfirmationInput = passwordConfirmation.parent();

  // Remueve el icono de alerta o success del input
  password.removeClass("is-invalid");
  password.removeClass("is-valid");
  // Remueve la clase de has-danger y has-success al contenedor del input
  contPasswordInput.removeClass("has-danger");
  contPasswordInput.removeClass("has-success");
  // Se busca el mensaje de error y lo elimina
  contPasswordInput.find(".fv-plugins-message-container").remove()

  // Remueve el icono de alerta o success del input
  passwordConfirmation.removeClass("is-invalid");
  passwordConfirmation.removeClass("is-valid");
  // Remueve la clase de has-danger y has-success al contenedor del input
  contPasswordConfirmationInput.removeClass("has-danger");
  contPasswordConfirmationInput.removeClass("has-success");
  // Se busca el mensaje de error y lo elimina
  contPasswordConfirmationInput.find(".fv-plugins-message-container").remove()

  // Si password esta vacio
  if(password.val().length == 0){
      // Mensaje de error 
      const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "empty_pswd_error_text"], "Debe ingresar una nueva contraseña si desea actualizarla.");
      var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
      // Agrega el icono al input
      password.addClass("is-invalid");
      // Agrega la clase de has-danger al contenedor del input
      contPasswordInput.addClass("has-danger");
      // Se muestra el mensaje de error
      contPasswordInput.append(errorMsg);
      // Le suma al contador de errores
      error++;
  // Si password tiene menos de 6 caracteres
  } else if(password.val().length < 6) {
      // Mensaje de error
      const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "short_pswd_error_text"], "La contraseña debe contener al menos 6 caracteres.");
      var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
      // Agrega el icono al input
      password.addClass("is-invalid");
      // Agrega la clase de has-danger al contenedor del input
      contPasswordInput.addClass("has-danger");
      // Se muestra el mensaje de error
      contPasswordInput.append(errorMsg);
      // Le suma al contador de errores
      error++;
  } else {
      // Agrega el icono check al input
      password.addClass("is-valid");
      // Agrega la clase de has-success al contenedor del input
      contPasswordInput.addClass("has-success");
  }

  // Si password_confirmation no tiene caracteres
  if(password.val().length > 0 && passwordConfirmation.val().length == 0){
      // Mensaje de error
      const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "not_chr_confirmation_pswd_error_text"], "Las contraseñas no son iguales."); 
      var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
      // Agrega el icono al input
      passwordConfirmation.addClass("is-invalid");
      // Agrega la clase de has-danger al contenedor del input
      contPasswordConfirmationInput.addClass("has-danger");
      // Se muestra el mensaje de error
      contPasswordConfirmationInput.append(errorMsg);
      // Le suma al contador de errores
      error++;
  // Si password_confirmation esta vacio
  } else if(passwordConfirmation.val().length == 0){
      const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "empty_confirmation_pswd_error_text"], "Debe ingresar una nueva contraseña si desea actualizarla."); 
      var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
      // Agrega el icono al input
      passwordConfirmation.addClass("is-invalid");
      // Agrega la clase de has-danger al contenedor del input
      contPasswordConfirmationInput.addClass("has-danger");
      // Se muestra el mensaje de error
      contPasswordConfirmationInput.append(errorMsg);
      // Le suma al contador de errores
      error++;
  // Si password_confirmation y password no coinciden
  } else if(password.val() != passwordConfirmation.val()) {
      // Mensaje de error
      const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "not_match_pswd_error_text"], "Las contraseñas no son iguales."); 
      var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
      // Agrega el icono al input
      passwordConfirmation.addClass("is-invalid");
      // Agrega la clase de has-danger al contenedor del input
      contPasswordConfirmationInput.addClass("has-danger");
      // Se muestra el mensaje de error
      contPasswordConfirmationInput.append(errorMsg);
      // Le suma al contador de errores
      error++;
  } else {
      // Agrega el icono check al input
      passwordConfirmation.addClass("is-valid");
      // Agrega la clase de has-success al contenedor del input
      contPasswordConfirmationInput.addClass("has-success");
  }

  return error;
}

// Funcion que se ejecuta al clickear un checkbox en postulantes
function getPostulantsIds(value) {
	var allVals = []
  var stored_ids = localStorage.getItem("userIds");
  // debugger;
	if (!(stored_ids === "null" || stored_ids === null|| stored_ids === '')) {
    allVals = stored_ids.split(',')
	}
	if ($.inArray(value, allVals) >= 0) {
    allVals.splice( $.inArray(value, allVals), 1 );
	}else {
    allVals.push(value)
  }

  // Removiendo los nullos
  var filteredallVals = allVals.filter(function (el) {
    return (el != "null" || el != "");
  });

  localStorage.setItem("userIds", filteredallVals.join(','))

  // Si todos los checkbox seleccionados son igual/diferentes que el numero de ids de la consulta
  //que marque/desmarque el checkbox de select all

  // if (filteredallVals.length === $('input#all_ids').val().split(',').length ){
  //   $('input#check_for_select_all').prop("checked", true);
  //   localStorage.setItem("userIdsSelectAll", true);
  // }else{
  //   $('input#check_for_select_all').prop("checked", false);
  //   localStorage.setItem("userIdsSelectAll", false);
  // }

	return filteredallVals
}
// Funcion que se ejecuta al clickear un checkbox en postulantes
function getAdminUsersIds(value) {
	var allVals = []
  var stored_ids = localStorage.getItem("userAdminIds");
  // debugger;
	if (!(stored_ids === "null" || stored_ids === null|| stored_ids === '')) {
    allVals = stored_ids.split(',')
	}
	if ($.inArray(value, allVals) >= 0) {
    allVals.splice( $.inArray(value, allVals), 1 );
	}else {
    allVals.push(value)
  }

  // Removiendo los nullos
  var filteredallVals = allVals.filter(el => el != "null" && el !== "");

  localStorage.setItem("userAdminIds", filteredallVals.join(','))

  // Si todos los checkbox seleccionados son igual/diferentes que el numero de ids de la consulta
  //que marque/desmarque el checkbox de select all
  let all_ids_input_length = $('input#all_ids').val().split(',').filter(el => el != "null" && el !== "").length

  if (filteredallVals.length === all_ids_input_length && all_ids_input_length > 0){
    $('input#check_for_select_all_admin').prop("checked", true);
    localStorage.setItem("userAdminIdsSelectAll", true);
  }else{
    $('input#check_for_select_all_admin').prop("checked", false);
    localStorage.setItem("userAdminIdsSelectAll", false);
  }

	return filteredallVals
}

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
